import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { endpoints } from "../api/endpoint";

const getCities = async () => {
  const response = await axios.get(endpoints.getCities);
  return response.data?.data || [];
};

export function useCities() {
  return useQuery({
    queryKey: ["cities"],
    queryFn: getCities,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
  });
}
